export default __webpack_public_path__ + "static/media/headphone1.758e5928.jpg";